import React, { useState, useCallback } from 'react';
import Helmet from 'react-helmet';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import './Results.scss';

import { get } from '@services';
import { api } from '@configs/routes.json';
import { IApplicationState } from '@store';
import { useTheme } from '@hooks';
import { ResultsTable } from './components/ResultsTable/ResultsTable';

type BatchReportState = 'Disabled' | 'ReportNA' | 'ReportAvailable';

const Results: React.FC = () => {
  const { t } = useTranslation();
  const [key, setKey] = useState(1);

  const theme = useTheme();

  const [tableCount, setTableCount] = useState({
    count: 0,
    total: 0,
  });

  // const [data, setData] = React.useState<SampleDetailWithOrderInfo[]>([]);
  // const [requestStatus, setRequestStatus] = React.useState<RequestStatus>(0);

  const [reportState, setReportState] =
    React.useState<BatchReportState>('Disabled');

  const activeAccountId = useSelector(
    (state: IApplicationState) => state.projectPicker.activeAccountId
  );

  const activeProjectId = useSelector(
    (state: IApplicationState) => state.projectPicker.activeProjectId
  );

  React.useEffect(() => {
    setKey((prev) => prev + 1);
  }, [activeAccountId, activeProjectId, theme]);

  React.useEffect(() => {
    get(api.reports.getState.replace(':type', 'CDxBatch'))
      .then((response) => {
        return response.json();
      })
      .then((response: BatchReportState) => {
        setReportState(response);
      })
      .catch((error) => {
        console.error(error);
      });
  }, [activeAccountId, activeProjectId]);

  const setTableCountCallback = useCallback((count) => {
    setTableCount({
      count: count.offset,
      total: count.numTotal,
    });
  }, []);

  const loadResultsTable = useCallback(() => {
    return <ResultsTable key={key} callbackCount={setTableCountCallback} />;
  }, [key]);

  return (
    <>
      <Helmet>
        <title>{t('results_title')}</title>
      </Helmet>
      <div id='title-count' className='mt-2'>
        <div id='title-count-left' className='order-header mb-2 clearfix'>
          <div className='float-left page-header-1'>
            <h1>{t('results_results')}</h1>
            {tableCount.total === 0 ? (
              <span className='list-count ml-1'>(0)</span>
            ) : tableCount.total === tableCount.count ? (
              <span className='list-count ml-1'>({tableCount.count})</span>
            ) : (
              <span className='list-count ml-1'>{`(Showing ${tableCount.count} out of ${tableCount.total})`}</span>
            )}
          </div>
        </div>
        <div id='title-count-right'>
          {tableCount.count > 0 && activeProjectId ? (
            <div
              className={`d-inline-block ${
                reportState === 'Disabled' ? 'invisible' : ''
              }`}
            >
              <a
                className={`btn btn-primary btn-sm ${
                  reportState === 'ReportNA' ? 'disabled' : ''
                }`}
                role='button'
                href={`${api.reports.getLatest.replace(
                  ':type',
                  'CDxBatch'
                )}?projectid=${activeProjectId}`}
                download
              >
                <i className='fas fa-arrow-circle-down mr-1'></i>
                <span className='text-uppercase'>
                  {t('results_order_downloadLatestBatchReport')}
                </span>
              </a>
            </div>
          ) : null}
        </div>
      </div>
      <hr className='m-0' />

      {loadResultsTable()}
    </>
  );
};

export default Results;
